export const arrayHead = <T>(ts: T[]): T | undefined => ts[0];
